export default "<two-factor-protection\n  is-protected=\"vm.isProtected\"\n  on-resolve=\"vm.resolved(data, response)\">\n</two-factor-protection>\n";